<template>
    <div class="content-wrapper container container-margin" id="team">
        <div class="team-screen" data-id="team">
            <div class="row">
                <div class="col-12 col-md-8 offset-md-2 content-left-aligned">
                    <h2>The team</h2>
                    <p class="intro">
                        Sisterhood is being developed by a small team of storytellers and makers with various
                        professional backgrounds, some with a lot of game design experience, and others with none at
                        all. Inspired by the adventurous women, we challenge ourselves to break with (game) conventions
                        and look beyond boundaries.
                    </p>

                    <TeamMember v-for="teamMember in this.team" :member="teamMember"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TeamMember from "@/components/TeamMember.vue";
export default {
    name: "Team",
    components: {
        TeamMember
    },
    data() {
        return {
            team: [
                {
                    name: "Paul Bierhaus",
                    role: "Artist",
                    image: "paul.png",
                    bio:
                        "Paul studied illustration and animation, and he has been creating and designing games since his younger years. Since 2006, he has mainly been developing serious games for various audiences, and he helped launch over 30 different games and interventions with a playful personality, such as  ‘Vil Du!?’; the intervention that was awarded the Dutch Game Award in 2017, aimed at sexually traumatised youths. He has also been devoting more and more of his time to developing interactive children’s stories, like the app ‘Een Verre Reis’ (A Far Journey), which received, among others, the Cinekid Gouden Guppy Award and the Lovie public award in 2017. As the initiator of Sisterhood, he is in charge of directing, writing the story and the visual production of worlds and characters."
                },
                {
                    name: "Erica Gasataya",
                    role: "Game Designer",
                    image: "erica.png",
                    bio:
                        "Erica has worked on many interactive animations and serious games in various roles, culminating in a position as lead designer. From making cheerful point & click adventures like ‘1000 jaar Utrecht’ (1000 years Utrecht), to creating  playful tools that alleviate children’s fear of injections, and shaping magical worlds that help teenagers in their mourning process, Erica has done it all. She is all about  making beautiful things, solving complex problems, and making a contribution. She previously spoke at the Control Conference Applied Games Summit, acted as jury member in the Global Game Jam and Dutch Game Awards, and she teaches game design at Grafisch Lyceum Utrecht. Together with Paul, she will be in charge of the game design for Sisterhood."
                },
                {
                    name: "Corina Maduro",
                    role: "Producer",
                    image: "corina.png",
                    bio:
                        "Corina is driven by the desire to bring as many people as possible in contact with art and culture. As an independent entrepreneur and concept developer, she collaborates with artists, other entrepreneurs and audiences to research all kinds of topics. For Sisterhood, she will be in charge of researching the historical characters and cultures, and she will take care of marketing and communication. Due to her previous experience as head of finance in various IT companies, she will also be in charge of accounting."
                },
                {
                    name: "Half Way Station",
                    role: "Musicians",
                    image: "halfwaystation.png",
                    bio:
                        "The group Half Way Station consists of composers with a true DIY mentality. They have a love of special instruments, microphones and natural reverbs, making their music beloved soundtracks for all kinds of projects. For instance, they wrote a much lauded track for the award-winning app ‘Een Verre Reis’ (A Far Journey), they provided the necessary accompaniment for theatre performances by Elfie Tromp, and their music has strengthened multiple films and documentaries. Not to be ignored are their two studio albums, ‘Dodo’ and ‘Moonshine’. Their work has been awarded with, among others, the ‘Grand Prix du Jury Génération Réservoir 2015’. For Sisterhood, they will support the gameplay and storytelling with music and sound effects."
                },
                {
                    name: "Minna Viitalähde",
                    role: "Graphic Designer",
                    image: "minna.png",
                    bio:
                        "Minna is a graphic designer who specialises in all kinds of design skills, from branding to illustration. For Sisterhood, she will be in charge of designing various in-game interfaces, as well as the branding of the website and social media."
                }
            ]
        };
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";

.intro {
    margin-bottom: 60px;
}

.team-member {
    position: relative;
    margin-bottom: 60px;

    p {
        color: $grey;
        margin-top: 0px;

        @include font-size(1.4);
        @include line-height(1.8);

        @include respond-to("medium") {
            @include font-size($base-font-size);
            @include line-height($base-line-height);
        }
    }

    .social-media {
        display: none;
        position: absolute;
        right: 0;
        top: 0;
        padding: 0;
        margin: 0;

        &.mobile {
            display: block;
            position: static;
        }
    }

    &:hover {
        .social-media {
            display: block;
        }
    }
}

.social-media {
    li {
        display: inline-block;
        list-style: none;
        margin: 0 5px;

        a {
            img {
                width: 24px;
                height: auto;
            }
        }
    }
}
</style>
